export default class ReactFramageSliceElement extends HTMLElement {}
